// @flow
import React, { PureComponent } from 'react'
import classnames from 'classnames'

import {withTranslate} from '../translation'
import provinces from './provinces.json'

type Props = {
  value: string,
  name: string,
  handleChange: Function,
  className: string,
  t: Function,
}

export class SelectProvince extends PureComponent<Props>{
  render() {
    const {value, name, handleChange, className, t} = this.props
    const classNames = classnames('select', className)
    return(
      <div className={classNames}>
        <select value={value} name={name} onChange={handleChange} className="w-full">
        {
          provinces.map((province, index) =>
          <option key={index} value={province.name}>{province.name}</option>)
        }
        </select>
      </div>
    )
  }
}

export default withTranslate(SelectProvince)
